import { jsx } from 'react/jsx-runtime';
import { Button } from '../ui/button.js';
import { cn } from '../../lib/utils.js';

const ButtonProgress = ({
  percentage = 0,
  remainingText = "",
  completeText = "",
  className,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    Button,
    {
      size: "lg",
      className: cn(
        "w-full relative overflow-hidden",
        // (percentage >= 100 ) && 'before:bg-primary-background-05',
        className
      ),
      ...props,
      children: /* @__PURE__ */ jsx(
        "span",
        {
          className: cn(
            "relative z-1 text-basic-06"
            // (percentage >= 100 ) && 'text-interactive-inverse',
          ),
          children: percentage >= 100 ? completeText : remainingText
        }
      )
    }
  );
};

export { ButtonProgress };
